import React, { useEffect, useCallback } from "react";
import NotificationAlert from "react-notification-alert";

// react-bootstrap components
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { useParams, useHistory } from "react-router-dom";
import { reportingAdded, reportingGetById, reportingLigneGetById } from "../../../Redux/reportingReduce";
import { getActiveActivite } from "../../../Redux/activiteReduce";
import { useDispatch } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";


function AjouterReporting({ client }) {
  const dispatch = useDispatch();
  const location = useParams();
  const navigate = useHistory();
  if (isNaN(location.id) === true) document.title = "Ajouter reporting";
  else document.title = "Modifier reporting";
  const [titre, setTitre] = React.useState(null);
  const [activite, setActivite] = React.useState([]);
  const [alert, setAlert] = React.useState(null);
  var annee = localStorage.getItem("annee");
  const [optionActivite, setOptionActvite] = React.useState([]);
  const [date, setDate] = React.useState(() => {
    const today = new Date();
    return localStorage.getItem("date") ? localStorage.getItem("date") : today.toISOString().split('T')[0];
  });
  const [id, setId] = React.useState(0);

  const notificationAlertRef = React.useRef(null);

  const getActivite = useCallback(
    async (p) => {
      var poless = await dispatch(getActiveActivite());
      var entities = poless.payload;
      var arrayOption = [];
      entities.forEach((e) => {
        arrayOption.push({ value: e.id, label: e.nom });
        // if (e.id === p) {
        //   setPoleSelect({ value: e.id, label: e.nom });
        // }
      });
      setOptionActvite(arrayOption);
    },
    [dispatch]
  );

  const notify = (place, msg, type) => {
    var options = {};
    options = {
      place: place,
      message: (
        <div>
          <div>{msg}</div>
        </div>
      ),
      type: type,
      icon: "nc-icon nc-bell-55",
      autoDismiss: 7,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  function submitForm(event) {
    if (titre == null) {
      notify("tr", "Reporting est obligatoire", "danger");
      return;
    } else if (activite.length == 0) {
      notify("tr", "Sélectionnez au moins une activité", "danger");
      return;
    } else if (activite.some(el => el.activite == null || el.activite === "")) {
      notify("tr", "Chaque activité doit avoir un nom valide", "danger");
      return;
    } else {
      dispatch(reportingAdded({ titre, id, date, activite, client, annee })).then(e => {
        if (e.payload === true) {
          if (isNaN(location.id) === true)
            notify("tr", "Insertion avec succès", "success");
          else
            notify("tr", "Modification avec succès", "success");

          setTimeout(async () => {
            listeReporting();
          }, 1500);
        } else {
          notify("tr", "Problème de connexion", "danger");
        }
      });
    }
  }


  useEffect(() => {
    async function getReporting() {
      if (isNaN(location.id) === false) {
        var reporting = await dispatch(reportingGetById(location.id));
        var entities = reporting.payload;
        if (entities === false) {
          navigate.push(client + '/listReporting');
        }
        else {
          var paraLigne = await dispatch(reportingLigneGetById(location.id));
          var paraLigneEntities = paraLigne.payload;
          setTitre(entities.titre);
          setDate(entities.date);
          setId(location.id);
          var arrayLigne = []
          if (paraLigneEntities.length > 0) {
            paraLigneEntities.forEach(element => {
              arrayLigne.push({ id: element.id, activite: element.id_activite, commentaire: element.commentaire, activiteSelect: { label: element.activites.nom, value: element.id_activite } })
            });

          }
          console.log(arrayLigne)
          setActivite(arrayLigne);
        }
      }
    }
    getReporting();
    getActivite()
  }, [location.id, dispatch, navigate]);


  const hideAlert = () => {
    setAlert(null);
  };
  const confirmMessage = (id) => {
    setAlert(
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title="Êtes-vous sûr de supprimer?"
        onConfirm={() => deleteLigne(id)}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="info"
        cancelBtnBsStyle="danger"
        confirmBtnText="Oui"
        cancelBtnText="Non"
        showCancel
      ></SweetAlert>
    );
  };
  function deleteLigne(id) {
    var list = [...activite];
    list.splice(parseInt(id), 1);
    setActivite(list);
    notify("tr", "Supprimer avec succes", "success");
    hideAlert();
  }
  function listeReporting() {
    navigate.push(client + '/listReporting');
  }


  function AjoutLigne(event) {
    var list = [];
    if (activite.length > 0) list = [...activite];
    list[list.length] = {
      id: null,
      commentaire: null,
      activiteSelect: null,
      activite: null,
    };
    setActivite(list);
  }


  return (
    <>
      <Container fluid>
        {alert}
        <div className="rna-container">
          <NotificationAlert ref={notificationAlertRef} />
        </div>
        <div className="section-image">
          <Container>
            <Row>
              <Col md="12">
                <Button
                  id="saveBL"
                  className="btn-wd btn-outline mr-1 float-left"
                  type="button"
                  variant="info"
                  onClick={listeReporting}
                >
                  <span className="btn-label">
                    <i className="fas fa-list"></i>
                  </span>
                  Retour à la liste
                </Button>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <Form action="" className="form" method="">
                  <Card>
                    <Card.Header>
                      <Card.Header>
                        <Card.Title as="h4">
                          {typeof location.id == "undefined" ? "Ajouter Rapporting" : "Modifier Rapporting"}
                        </Card.Title>
                      </Card.Header>
                    </Card.Header>
                    <Card.Body>
                      <Row>
                        <Col className="pr-1" md="6">
                          <Form.Group>
                            <label>TiTre * </label>
                            <Form.Control
                              defaultValue={titre}
                              placeholder="Titre"
                              type="text"
                              onChange={(value) => {
                                setTitre(value.target.value);
                              }}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                        <Col className="pr-1" md="6">
                          <Form.Group>
                            <label>date * </label>
                            <Form.Control
                              defaultValue={date}
                              placeholder="Date"
                              type="date"
                              onChange={(value) => {
                                setDate(value.target.value);
                              }}
                            ></Form.Control>
                          </Form.Group>
                        </Col>

                      </Row>
                      <Row>
                        <Col md="12">
                          <hr></hr>
                          <br></br>
                          <Button
                            className="btn-fill pull-right"
                            type="button"
                            variant="info"
                            nom="redac"
                            onClick={(ev) => AjoutLigne()}
                          >
                            <i className="fas fa-plus"></i> Ajouter
                          </Button>
                          <br></br>
                          <table className="table"  >
                            <thead>
                              <tr>
                                <th>Activité </th>
                                <th>Commentaire</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {activite.length > 0 ? activite.map((val, key) => {
                                return (
                                  <tr key={key}>
                                    <td>

                                      <Form.Group>
                                        <label>Acitivité * </label>
                                        <Select
                                          className="react-select primary"
                                          classNamePrefix="react-select"
                                          name="singleSelect"
                                          value={val.activiteSelect}
                                          onChange={(value) => {
                                            var list = [...activite];
                                            list[key] = {
                                              ...list[key],
                                              activite: value.value,
                                              activiteSelect: value,
                                            };
                                            setActivite(list);
                                          }}
                                          options={optionActivite}
                                          placeholder="Activite"
                                        />
                                      </Form.Group>
                                    </td>
                                    <td>
                                      <Form.Group>
                                        <label>Commentaire </label>
                                        <Form.Control
                                          as="textarea"
                                          placeholder="Commentaire"
                                          value={val.commentaire}
                                          onChange={(value) => {
                                            var list = [...activite];
                                            list[key] = {
                                              ...list[key],
                                              commentaire: value.target.value,
                                            };
                                            setActivite(list);
                                          }}
                                        />
                                      </Form.Group>
                                    </td>

                                    <td>
                                      <div className="actions-right block_action">
                                        <Button
                                          onClick={(ev) => {
                                            confirmMessage(key);
                                          }}
                                          variant="danger"
                                          size="sm"
                                          className="text-danger btn-link delete"
                                        >
                                          <i className="fa fa-trash" />
                                        </Button>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              }) : <tr><td></td></tr>}
                            </tbody>
                          </table>
                        </Col>
                      </Row>
                      <Button
                        className="btn-fill pull-right"
                        type="button"
                        variant="info"
                        onClick={submitForm}
                      >
                        Enregistrer
                      </Button>
                      <div className="clearfix"></div>
                    </Card.Body>
                  </Card>
                </Form>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>
    </>
  );
}

export default AjouterReporting;
